import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NewBannerContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getNewBanners(id: string): Observable<any> {
    return this.getNewBannersContents(id).pipe(
      map(res => this.extractResult(res)),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private mapBanner(banner) {
    const hasMenu = !!banner.menu && banner.menu.length > 0;
    let menu = [];
    if (hasMenu) {
      menu = banner.menu.map(menuItem => {
        return {
          title: menuItem.title ? menuItem.title : '',
          url: menuItem.uRL ? menuItem.uRL : '',
          modal:
            menuItem.modal && menuItem.modal[0] ? menuItem.modal[0].id : null,
          page: menuItem.pagina
            ? menuItem.pagina.length > 0
              ? '/paginas/' + menuItem.pagina[0].flatData.slug
              : null
            : null
        };
      });
      banner.menu = menu;
    }
    return banner;
  }

  private extractResult(res) {
    return this.mapBanner(res.data.queryNewBannersContents[0].flatData);
  }

  private getNewBannersContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryNewBannersContents(filter: "id eq '${id}'") {
          flatData {
            title
            subtitle
            description
            name
            accreditedNetwork
            buttons {
                title
                url
                butttonBackgroundColor
                buttonBorderColor
                buttonTextColor
                modal {
                  id
                }
                page {
                  id
                }
                target {
                  ... on Formulario {
                    id
                  }
                }
            }
            menu {
                title
                uRL
                modal {
                  id
                }
                page {
                  flatData {
                    slug
                  }
                }
            }
            background { url }
            partnerLogo { url }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
